module.exports = __webpack_public_path__ + "img/map-marker.2aacdccf.png";